import { useAppSelector } from 'app/hooks';
import AlertModal from 'components/common/AlertModal';
import useGlobalModal from 'components/common/GlobalModal/useGlobalModal';
import { MenuDetail } from 'features/SubTitleMenu/models/SubTitleMenu';
import { selectIsEditMode } from 'features/common/editModeSlice';
import { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import 'react-datepicker/dist/react-datepicker.css';
import { useTranslation } from 'react-i18next';
import './Detail.scss';
import SubTitleMenuFormDetail from './components/SubTitleMenuFormDetail';
import service from './services';
interface EditModalInterface {
  id: string;
  show: boolean;
  // handleCloseModalEdit: () => void;
  targetDate?: Date;
  onClose?: (status: boolean, targetDate?: Date) => void;
  dataTable?: MenuDetail[];
  setDataTable?: (subTitleMenus: MenuDetail[]) => void;
}

function DetailModal({ id, show, targetDate, onClose, dataTable, setDataTable }: EditModalInterface) {
  const { t } = useTranslation();
  const [subTitleMenu, setSubTitleMenu] = useState<MenuDetail>();
  const { showGlobalModal } = useGlobalModal();

  // selectors
  const isEditMode = useAppSelector(selectIsEditMode);

  useEffect(() => {
    const getSubTitleMenu = async (id: string) => {
      await service
        .getMenu(id)
        .then((data) => {
          return data.data;
        })
        .then((data) => {
          setSubTitleMenu(data);
        });
    };
    if (id) {
      getSubTitleMenu(id).catch(() => {
        showGlobalModal &&
          showGlobalModal(() => (
            <AlertModal
              title={t('SubTitleMenu.Validator.error')}
              message={t('SubTitleMenu.Validator.500')}
            ></AlertModal>
          ));
      });
    }
  }, [id, showGlobalModal, t]);

  function handleClose() {
    onClose?.(false, targetDate);
  }

  function handleCloseModalEdit(status: boolean) {
    onClose?.(status, targetDate);
  }

  return (
    <Modal show={show} onHide={handleClose} size="xl">
      <Modal.Header closeButton className={isEditMode ? 'reedit-mode-wrapper' : ''}></Modal.Header>
      <Modal.Body className={isEditMode ? 'reedit-mode-wrapper' : ''}>
        {subTitleMenu && (
          <SubTitleMenuFormDetail
            menuDetail={subTitleMenu}
            id={id}
            handleCloseModalEdit={handleCloseModalEdit}
            dataTable={dataTable}
            setDataTable={setDataTable}
          ></SubTitleMenuFormDetail>
        )}
      </Modal.Body>
    </Modal>
  );
}
export default DetailModal;
